import { ReactComponent as MovingWaldoLogo } from '../../../assets/logo.svg'
import { usePlatformLogo, usePlatformName } from '../../../modules/appConfig'

const PlatformLogo: React.FC = () => {
  const platformLogo = usePlatformLogo()
  const platformName = usePlatformName()

  if (!platformLogo) {
    return null
  }

  return (
    <div className="flex h-full max-w-[calc(100vw-80px)] items-end gap-x-4 overflow-hidden md:gap-x-8">
      <MovingWaldoLogo className="h-4/5 md:h-[90%]" />
      <img src={platformLogo} alt={platformName} className="h-4/5 md:h-[90%]" />
    </div>
  )
}

export default PlatformLogo
